import { Injectable } from '@angular/core';

export class ROUTE {
  static readonly HOME = '';
  static readonly OVERZICHT = 'overzicht';
  static readonly PREADVIES = 'preadvies';
  static readonly AANVRAAG = 'aanvraag';
  static readonly AANVRAAG_DETAIL = 'aanvraag/:id';
  static readonly AANVRAAG_PROJECTINFO = 'aanvraag/:id/projectinfo';
  static readonly AANVRAAG_LOCATIE = 'aanvraag/:id/locatie';
  static readonly AANVRAAG_PARTNERS = 'aanvraag/:id/partners';
  static readonly AANVRAAG_KOSTEN = 'aanvraag/:id/kosten';
  static readonly AANVRAAG_PROJECT_OMSCHRIJVING = 'aanvraag/:id/omschrijving';
  static readonly AANVRAAG_BIJLAGEN = 'aanvraag/:id/bijlagen';
  static readonly AANVRAAG_INGEDIEND = 'aanvraag/:id/ingediend';
  static readonly AANVRAAG_PDF = 'aanvraag/:id/pdf';

  static readonly TOKEN = 'token';
  static readonly LOGIN = 'login';
  static readonly ERROR403 = '403';
  static readonly ERROR451 = '451';

  static readonly PROJECTINFO_VISIE = 'visie';
  static readonly PROJECTINFO_MOTIVATIE = 'motivatie';
  static readonly PROJECTINFO_DUURZAAMHEID = 'duurzaamheid';

  static getAanvraagChildRoute(route: string) {
    return route.replace(`${ROUTE.AANVRAAG}/`, '');
  }
}

@Injectable()
export class RouteService {
  constructor() {}

  getHomeRoute(): string[] {
    return [ROUTE.HOME];
  }

  getError403Route(): string[] {
    return [ROUTE.ERROR403];
  }
  getError451Route(): string[] {
    return [ROUTE.ERROR451];
  }

  getOverzichtRoute(): string[] {
    return [ROUTE.OVERZICHT];
  }

  getStappenplanRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_DETAIL.replace(':id', id.toString())];
  }

  getProjectinfoRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_PROJECTINFO.replace(':id', id.toString())];
  }

  getLocatieRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_LOCATIE.replace(':id', id.toString())];
  }

  getPartnersRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_PARTNERS.replace(':id', id.toString())];
  }

  getKostenRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_KOSTEN.replace(':id', id.toString())];
  }

  getProjectOmschrijvingRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_PROJECT_OMSCHRIJVING.replace(':id', id.toString())];
  }

  getBijlagenRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_BIJLAGEN.replace(':id', id.toString())];
  }

  getIngediendRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_INGEDIEND.replace(':id', id.toString())];
  }

  getPdfRoute(id: string): string[] {
    return ['/' + ROUTE.AANVRAAG_PDF.replace(':id', id.toString())];
  }
}
